import { reactive, computed, watch } from 'vue';

// 生产默认值必须为空；真实余额、卡片、流水和验证码只能来自已认证 API。
const seed = {
  profile: { name: '', email: '', avatar: '', joinedAt: '', status: 'active', deviceId: '' },
  account: { balance: 0, cardBalance: 0, depositAddress: '', deposits: [], ledger: [], depositRules: { feeRate: 5, minimumFee: 3, minimumDeposit: 5 } },
  cards: [],
  transactions: [],
  otp: [],
  users: [],
  apiLogs: [],
  auditLogs: [],
  features: { cardBinding: true, qrDeposit: false, cardWithdrawal: false },
  settings: { demoMode: false, feeRate: 1, cardOpenFee: 1, dailyLimit: 50000, defaultLocale: 'zh-CN', callbackUrl: '', otpRetention: 30, autoFreeze: true }
};

function loadState() {
  try {
    const saved = JSON.parse(localStorage.getItem('u1card-state-v3'));
    return saved ? { ...structuredClone(seed), ...saved } : structuredClone(seed);
  } catch {
    return structuredClone(seed);
  }
}

// 清除旧版本写死演示数据，避免升级后继续从浏览器缓存中出现假余额、假卡片和固定地址。
localStorage.removeItem('u1card-state');
localStorage.removeItem('u1card-state-v2');
export const state = reactive(loadState());
export const accountTotal = computed(() => state.account.balance + state.account.cardBalance);

watch(state, (value) => localStorage.setItem('u1card-state-v3', JSON.stringify(value)), { deep: true });

export function applyCardSummary(summary = {}) {
  state.cards = Array.isArray(summary.cards) ? summary.cards : [];
  state.transactions = Array.isArray(summary.transactions) ? summary.transactions : [];
  state.otp = Array.isArray(summary.otp) ? summary.otp : [];
  state.account.cardBalance = Number.isFinite(Number(summary.cardBalance)) ? Number(summary.cardBalance) : 0;
}

export function setUserStatus(id, status) {
  const user = state.users.find((item) => item.id === id);
  if (user) user.status = status;
}

export function setCardStatus(id, status) {
  const card = state.cards.find((item) => item.id === id);
  if (card) card.status = status;
}

export function addTransaction(transaction) {
  state.transactions.unshift({ id: `TXN-${Date.now()}`, at: new Date().toLocaleString('sv-SE'), status: 'credited', ...transaction });
}
